export default __webpack_public_path__ + "static/media/boelterHero.70b76a5f.webp";